import AuthInfo from "../models/auth-info";

class StorageService {
  setAuthInfo(authInfo: AuthInfo) {
    localStorage.setItem('auth', JSON.stringify(authInfo));
  }

  getAuthInfo(): AuthInfo {
    const rawAuth = localStorage.getItem('auth');

    if (rawAuth) {
      return Object.assign(new AuthInfo(), JSON.parse(rawAuth));
    }

    return null;
  }

  removeAuthInfo() {
    localStorage.removeItem('auth');
  }

  getAccessToken(): string {
    const authInfo = this.getAuthInfo();

    return authInfo?.accessToken;
  }

  getRefreshToken(): string {
    const authInfo = this.getAuthInfo();

    return authInfo?.refreshToken;
  }

  getEmployee(): Employee {
    const authInfo = this.getAuthInfo();

    return authInfo?.employee;
  }
}

export default StorageService;